import { mount } from "../utils/dom.js";
import { Calculator } from "../components/calc/Calculator.js";

export function mountCalculator() {
  mount("calculator-mount", Calculator);
}
